// Project imports
import { useSnackMessages } from 'hooks/useSnackMessages';
import MedicalHealthApi from '../api/MedicalHealthApi';
import * as actionTypes from 'store/actions';

// third parties imports
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { decodeToken } from 'utils/auth';

export const useAuthDoctorStore = () => {
    const { status, user } = useSelector((state) => state.auth);
    const { msgBasicError } = useSnackMessages();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    /**
     *  Register a new user
     * @param {*} - { fname, lname, email, password, role }
     */
    const registerDoctor = async ({ fname, lname, email, password }) => {
        try {
            const response = await MedicalHealthApi.post('/doctor/register', {
                fname,
                lname,
                email,
                password
            });

            if (response.status === 201) {
                startSession({ email, password });
            }
        } catch (e) {
            console.error(e);
            const msg = e?.response?.data?.msg || e?.message || 'Error registrando doctor';
            msgBasicError(msg, true);
        } finally {
        }
    };

    /**
     *  Start a new session - Login
     * @param {*} param0  - { email, password }
     */
    const startSession = async ({ email, password }, { setSubmitting } = {}) => {
        try {
            const { status, data } = await MedicalHealthApi.post('/doctor/login', {
                email,
                password
            });

            if (status === 200) {
                const { token } = data;

                const doctor = decodeToken(token);

                localStorage.setItem('token', token);

                dispatch({
                    type: actionTypes.LOGIN,
                    user: doctor
                });

                navigate('/', { replace: true });
            }
        } catch (e) {
            console.error(e);
            const msg = e?.response?.data?.msg || e?.message || 'Error en logging';
            msgBasicError(msg, true);
        } finally {
            if (typeof setSubmitting === 'function') setSubmitting(false);
        }
    };

    return {
        status,
        user,
        registerDoctor,
        startSession
    };
};
